import React from "react";
import { connect } from "react-redux";
import { validateExternalToken } from "../../appRedux/reducers/Auth";
import CircularProgress from "components/CircularProgress/index";
import { Redirect } from "react-router-dom";

class ExternalAccess extends React.Component {
    getAccessToken = () => {
        const location = this.props.location || window.location;
        const params = new URLSearchParams(location.search);
        return params.get("access_token");
    }

    validateData = async (token) => {
        await this.props.validateExternalToken(token);
        
    }

    componentDidMount() {
        const accessToken = this.getAccessToken();
        if(accessToken) {
            this.validateData(accessToken);
        }
    }
    render() {
        const { authUser, loader, showMessage } = this.props;
        const accessToken = this.getAccessToken();
        if (loader || (accessToken && !(authUser && authUser.authorized) && !showMessage)) {
            return (
            <div className="gx-loader-view">
                <CircularProgress />
            </div>
            );
        }
        if (authUser && authUser.authorized) {
            return <Redirect to="/analytics" />;
        } else {
            return <Redirect to="/signin" />;
        }
    }
}
const mapStateToProps = ({ auth, company }) => {
  const { authUser, initURL, loader, showMessage } = auth;
  return {
    authUser,
    initURL,
    loader,
    showMessage,
    company: company.company
  };
};

export default connect(mapStateToProps, {
  validateExternalToken,
})(ExternalAccess);
